import { getContent } from "../../Core/Content/store";
import type { PortfolioHighlightModel } from "../../Core/Models/PackageModels";

export const getPortfolioHighlightsFn = (): PortfolioHighlightModel[] => getContent("portfolio").items as PortfolioHighlightModel[];
